import { Ref, ref } from '@vue/composition-api';
interface Posistion {
  x: Number;
  y: Number;
}
interface DragWidgetSize {
  width: Number;
  height: Number;
}
class DragFileHandler {
  shouldShowDragWidget: Ref<boolean> = ref(false);
  dragWidgetSize: Ref<DragWidgetSize> = ref({
    width: 200,
    height: 56,
  });
  dragWidgetPos: Ref<Posistion> = ref({
    x: -1,
    y: -1,
  });
  dragWidgetFileItem: Ref<any> = ref({
    name: '',
    isAuthorized: true,
  });
  dragWidgetFileCount: Ref<Number> = ref(0);
  draggingFileList: Ref<any[]> = ref([]);
  draggingRowKeys: Ref<any[]> = ref([]);
  hideDragView() {
    this.shouldShowDragWidget.value = false;
    this.dragWidgetPos.value = {
      x: -1,
      y: -1,
    };
    this.dragWidgetFileItem.value = {
      name: '',
      isAuthorized: true,
    };
    this.dragWidgetFileCount.value = 0;
    this.draggingFileList.value = [];
    this.draggingRowKeys.value = [];
  }
  showDragViewAt(pos: Posistion) {
    if (this.shouldShowDragWidget.value === false) {
      this.shouldShowDragWidget.value = true;
    }
    this.dragWidgetPos.value = pos;
  }
  fillInfo(mainFile: any, draggingFileList: any[], draggingRowKeys: any[], widgetSize?: DragWidgetSize) {
    this.dragWidgetFileItem.value = mainFile;
    this.dragWidgetFileCount.value = draggingFileList.length;
    this.draggingFileList.value = draggingFileList;
    this.draggingRowKeys.value = draggingRowKeys;
    if (widgetSize) {
      this.dragWidgetSize.value = widgetSize;
    }
  }
}
const dragFileHandler = new DragFileHandler();
export { dragFileHandler, DragWidgetSize };
